import Vue from 'vue'
import Router from 'vue-router'
import app from '@/App'
import webindex from '@/components/webindex'
import introduction from '@/components/introduction'
import projects from '@/components/projects'
import qualification from '@/components/qualification'
import ceo from '@/components/ceo'
import newscenter from '@/components/newscenter'
import contact from '@/components/contact'
import buliding from '@/components/buliding'
import traffic from '@/components/traffic'
import traffic1 from '@/components/traffic1'
import traffic2 from '@/components/traffic2'
import traffic3 from '@/components/traffic3'
import traffic4 from '@/components/traffic4'
import security from '@/components/security'
import air from '@/components/air'
import news from '@/components/news'
import news2 from '@/components/news2'
import news3 from '@/components/news3'
import newsdetailed from '@/components/newsdetailed'
import newlist from '@/components/newlist'
import newlist2 from '@/components/newlist2'
import newlist3 from '@/components/newlist3'
import newlist4 from '@/components/newlist4'
import project0 from '@/components/case/project0'
import project13 from '@/components/case/project13'
import project1 from '@/components/case/project1'
import project2 from '@/components/case/project2'
import project3 from '@/components/case/project3'
import project4 from '@/components/case/project4'
import project5 from '@/components/case/project5'
import project6 from '@/components/case/project6'
import project7 from '@/components/case/project7'
import project8 from '@/components/case/project8'
import project9 from '@/components/case/project9'
import project10 from '@/components/case/project10'
import project11 from '@/components/case/project11'
import project12 from '@/components/case/project12'
import industry from '@/components/qn/industry'
import security2 from '@/components/qn/security2'
import rd11 from '@/components/qn/rd11'
import otherIndustries from '@/components/qn/otherIndustries'
import engineering from '@/components/qn/engineering'
import honor from '@/components/qn/honor'
import other from '@/components/qn/other'
import download from '@/components/download'
import VueRouter from 'vue-router'
import login from '@/components/login'
import BootAnimation from '@/components/BootAnimation'
Vue.use(Router)

// const originalPush = VueRouter.prototype.push
// VueRouter.prototype.push=function push(location){
//   return originalPush.call(this.location).catch(err=>err)
// }



export default new Router({



  routes: [
    {
      path: '/BootAnimation',
      component: BootAnimation
    },
    {
      path: '/download',
      component: download
    },
    {
      path: "/login",
      component: login
    },
    {
      path: '/',
      redirect: '/webindex',

    },
    {
      path: '/webindex',
      component: webindex
    },
    {
      path: '/introduction',
      component: introduction
    },

    // 动态路由
    // {
    //   path: '/projects/:projectId',
    //   name: 'ProjectDetail',
    //   component: () => import('@/components/case/ProjectDetail.vue'),
    //   props: true // 将路由参数作为props传递给组件
    // },
    {
      path: '/projects',
      component: projects,
      redirect: '/projects/project0',
      children: [
        {
          path: 'project0',
          component: project0,
          name: 'heel0',
          meta: '首页',
        },
        {
          path: 'project1',
          component: project1,
          name: 'heel1',
          meta: '首页',
        },
        {
          path: 'project2',
          component: project2,
          name: 'heel2',
          meta: '首页',
        },
        {
          path: 'project3',
          component: project3,
          name: 'heel3',
          meta: '首页',
        },
        {
          path: 'project4',
          component: project4,
          name: 'heel4',
          meta: '首页',
        },
        {
          path: 'project5',
          component: project5,
          name: 'heel5',
          meta: '首页',
        },
        {
          path: 'project6',
          component: project6,
          name: 'heel6',
          meta: '首页',
        }, {
          path: 'project7',
          component: project7,
          name: 'heel7',
          meta: '首页',
        },
        {
          path: 'project8',
          component: project8,
          name: 'heel8',
          meta: '首页',
        }, {
          path: 'project9',
          component: project9,
          name: 'heel9',
          meta: '首页',
        }, {
          path: 'project10',
          component: project13,
          name: 'heel10',
          meta: '首页',
        },
        {
          path: 'project11',
          component: project10,
          name: 'heel11',
          meta: '首页',
        }, {
          path: 'project12',
          component: project11,
          name: 'heel12',
          meta: '首页',
        }, {
          path: 'project13',
          component: project12,
          name: 'heel13',
          meta: '首页',
        }

      ],
    },
    {
      path: '/qualification',
      component: qualification,
      redirect: '/qualification/industry',
      meta: '首页',
      children: [
        {
          path: 'industry',
          component: industry,
          // redirect: '/qualification/industry/security2',
          redirect: '/qualification/engineering',
          meta: '首页',
          children: [
            {
              path: 'security2',
              component: security2,
              name: 'heel',
              meta: '首页',
            },
            {
              path: 'rd11',
              component: rd11,
              name: 'heel',
              meta: '首页',
            },{
              path: 'otherIndustries',
              component:otherIndustries,
              name: 'heel',
              meta: '首页',
            }
          ]
        }, {
          path: 'engineering',
          component: engineering,
          name: 'heel',
          meta: '首页',
        },
        
        {
          path: 'honor',
          component: honor,
          name: 'heel',
          meta: '首页',
        },
        {
          path: 'other',
          component: other,
          name: 'heel',
          meta: '首页',
        }
      ]
    },
    {
      path: '/ceo',
      component: ceo
    },
    {
      path: '/newscenter',
      component: newscenter,
      redirect: '/newscenter/newlist',
      meta: '首页',
      children: [
        {
          path: 'newlist',
          name: 'heel',
          meta: '首页',
          component: newlist
        },
        {
          path: 'newlist2',
          component: newlist2,
          meta: '首页',
          name: 'heel',
        },
        {
          path: 'newlist3',
          component: newlist3,
          meta: '首页',
          name: 'heel',
        },
        {
          path: 'newlist4',
          component: newlist4,
          name: 'heel',
          meta: '首页',
        },
        {
          path: '/newsdetailed',
          component: newsdetailed
        },

      ]
    },

    {
      path: '/contact',
      component: contact
    },
    {
      path: '/buliding',
      component: buliding
    },
    {
      path: '/traffic',
      component: traffic
    },
    {
      path: '/traffic1',
      component: traffic1
    }, {
      path: '/traffic2',
      component: traffic2
    },
    {
      path: '/traffic3',
      component: traffic3
    },
    {
      path: '/traffic4',
      component: traffic4
    },
    {
      path: '/security',
      component: security
    },
    {
      path: '/air',
      component: air
    },

  ],

  scrollBehavior(to, from, savedPosition) {
    if (to.name !== 'heel') {
      return { x: 0, y: 0 };
    } else {
      console.log(123156456456485);
    }
  }

})





// WEBPACK FOOTER //
// ./src/router/index.js